// @flow
import createUniversalRoute from "../../utils/createUniversalRoute";
import blogRoutes from "../BlogLayout/routes";
import { BABY_THEME } from "../WhenShouldISell/index";

const routes = [
  {
    path: "/error",
    exact: true,
    name: "ServerError",
  },
  {
    path: "/:item?/area-check",
    name: "AreaCheckGate",
  },
  {
    path: "/press/:item",
    name: "PressSingle",
  },
  {
    path: "/customer-stories",
    exact: true,
    name: "CustomerStories",
  },
  {
    path: "/customer-stories/:item",
    name: "CustomerStory",
  },
  {
    path: "/guides/:item",
    name: "Guide",
  },
  {
    path: "/research/:story/2017/:country/:category",
    name: "ResearchStory",
  },
  {
    path: "/research",
    exact: true,
    name: "Research",
  },
  {
    path: "/smoke-tests/:item",
    name: "SmokeTest",
  },
  {
    path: "/stats/:city/postcode/:postcode/address/:addressId",
    name: "RedirectToAreaMarketReport",
  },
  {
    path: "/stats/:city",
    name: "RedirectToAreaMarketReport",
  },
  {
    path: "/property-market/:area*",
    name: "AreaMarketReport",
  },
  {
    path: "/for-sale/:postcodeSector/:roadName/:dealExternalId",
    name: "IndividualPropertyPage",
  },
  {
    path: "/blog",
    name: "BlogLayout",
    routes: blogRoutes,
  },
  {
    path: "/how-long-will-it-take-to-sell-my-house",
    name: "WhenShouldISell",
  },
  {
    path: "/baby-move-calculator",
    name: "WhenShouldISell",
    props: { theme: BABY_THEME },
  },
  {
    path: "/:item?",
    name: "Custom",
  },
];

export default routes.map<*>(createUniversalRoute);
